import React from 'react';
import DesktopProfileTop728x90Fs from './freestar/DesktopProfileTop728x90';
const DesktopProfileTop728x90 = ({ safety ='off'  })=>{
    return /*#__PURE__*/ React.createElement(DesktopProfileTop728x90Fs, {
        safety: safety
    });
};
DesktopProfileTop728x90.displayName = 'DesktopProfileTop728x90';
export default DesktopProfileTop728x90;
